<template>
    <div
        class="modal"
        :class="{ 'is-active': isShown }"
    >
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">

            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ trans.rename_modal_title }}
                </p>
                <button
                    aria-label="close"
                    class="delete"
                    @click="closeModal"
                ></button>
            </header>

            <section class="modal-card-body">
                <input
                    ref="filenameInput"
                    v-model="name"
                    class="input"
                    type="text"
                    @keyup.enter="confirmRename"
                />
            </section>

            <footer class="modal-card-foot">
                <button
                    class="button is-info"
                    @click="confirmRename"
                >
                    {{ trans.rename_confirm_button }}
                </button>
                <button
                    class="button is-outlined"
                    @click="closeModal"
                >
                    {{ trans.cancel }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "BaseFileRenameModal",
    data() {
        return {
            name: null,
        };
    },
    computed: {
        ...mapState('fileManagement', {
            isShown: 'fileRenameModalIsShown',
        }),
        ...mapState('fileManagement', [
            'actions',
            'trans',
            'selectedFile',
        ]),
        text() {
            return this.replaceWildcards(this.trans.delete_modal_text, {
                filename: this.selectedFile.name,
            });
        }
    },
    watch: {
        isShown(newValue, oldValue) {
            if (newValue === true) {
                this.name = this.selectedFile.name;
                this.$nextTick(() => this.selectFileNameInInput())
            }
        },
    },
    methods: {
        ...mapActions('fileManagement', {
            closeModal: 'hideFileRenameModal',
        }),
        ...mapActions('fileManagement', [
            'renameFile',
        ]),
        selectFileNameInInput() {
            let fileExtension = this.name.split('.').pop(),
                extensionIndex = this.name.indexOf(fileExtension) - 1;

            this.$refs.filenameInput.focus();
            this.$refs.filenameInput.setSelectionRange(0, extensionIndex);
        },
        confirmRename() {
            let isSameName = this.selectedFile.name === this.name;

            if (!isSameName) {
                this.renameFile({
                    file: this.selectedFile,
                    newName: this.name
                })
                .catch(error => {
                    let errorList = error.response.data.errors,
                        errorString = this.trans.errors.error_title;

                    for (let error in errorList) {
                        errorString += `<br>${errorList[error][0]}`;
                    }

                    this.showNotification(errorString, 680);
                });
            }

            this.closeModal();
        },
    },
}
</script>

<style scoped>
.modal-card {
    max-width: 500px;
    margin-top: 200px;
}

.modal-card-foot {
    padding-bottom: 20px;
}
</style>